"use client";

import { useSignalREvent } from "@/lib/signalr/useSignalREvent";
import { SIGNALR_EVENTS } from "@/lib/signalr/events";
import type { CcofCardChangedEvent } from "@/lib/signalr/types";
import type { DeepPartial } from "@/lib/object";
import { normalizeCardOnFile } from "@/features/payment/utils/normalizeCardOnFile";
import type { CardCollectionRow } from "../types";
import { CaptureLinkState } from "@/features/card-capture/staff";
import { useUpdateCardCollectionCacheEntry } from "./useUpdateCardCollectionCache";

function toCardCollectionPatch(
  patient: NonNullable<CcofCardChangedEvent["patient"]>,
): DeepPartial<CardCollectionRow> {
  return {
    patient: {
      practiceId: patient.practiceId!,
      firstName: patient.firstName!,
      lastName: patient.lastName!,
      dateOfBirth: patient.dateOfBirth!,
      mrn: patient.mrn!,
      phone: patient.phoneNumber ?? null,
      cardCapture: (patient.cardCapture as CaptureLinkState) ?? null,
      cardOnFile: normalizeCardOnFile(patient.cardOnFile),
    },
  };
}

export function useCardCollectionCardChangedEvent(): void {
  const updateCardCollectionCache = useUpdateCardCollectionCacheEntry();

  useSignalREvent<CcofCardChangedEvent>(
    SIGNALR_EVENTS.CCOF_CARD_CHANGED,
    (event) => {
      if (!event.patient?.patientId) return;

      updateCardCollectionCache(
        event.patient.patientId,
        toCardCollectionPatch(event.patient),
      );
    },
  );
}
